import React, { useState } from 'react';
import PageTemplate from '../components/Common/PageTemplate';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FaUsers, 
  FaCalendarAlt, 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaInstagram, 
  FaTwitter, 
  FaLinkedin,
  FaFacebook, 
  FaGlobe,
  FaChevronRight,
  FaHeart,
  FaStar,
  FaEye,
  FaArrowRight,
  FaSearch,
  FaFilter,
  FaPlay,
  FaPause,
  FaExpand,
  FaChevronDown,
  FaChevronUp,
  FaExternalLinkAlt,
  FaImage,
  FaVideo,
  FaChevronLeft
} from 'react-icons/fa';

const OgrenciTopluluklari = () => {
  const [expandedClub, setExpandedClub] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Real student clubs data
  const clubs = [
    {
      id: 1,
      name: "Hacettepe Üniversitesi Evrimsel Biyoloji ve Tıp Topluluğu (HÜEBTTO)",
      category: "akademik",
      department: "Biyoloji Bölümü",
      description: "Topluluğumuz okulumuzda ve toplumda güncel evrimsel biyoloji, genetik ve evrimsel tıp bilgisine dayalı bilincin oluşturulması, tanıtılması ve konuya ilginin çekilmesi bağlamında çeşitli faaliyetlerde bulunmaktadır. Düzenlediğimiz etkinliklerde başta Hacettepe Üniversitesi öğrencileri olmak üzere diğer üniversitelerdeki öğrenciler ve toplumun her kesiminden insanlar arasında bilimsel konuların konuşulması; öğrencilerin eleştirel düşünme, bilimsel metinleri inceleme ve sorgulama becerilerinin gelişimine yardımcı olunması; ülkemizde ve dünyada yapılan evrim, evrimsel genetik, evrimsel tıp çalışmaları ve güncel gelişmeler hakkında bilgi sahibi olunması; diğer bilim dallarına evrimsel bir perspektiften bakılması gibi temel hususların üzerinde durmaktadır.",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebttologo.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebto1.jfif",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebto2.jfif",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebto3.jfif",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebto4.jfif",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huebto5.jfif"
      ],
      foundedYear: "2020",
      contact: {
        instagram: "@huebtto",
        facebook: "https://www.facebook.com/HUEBTTO",
        twitter: "@huebtto"
      },
      activities: ["Arazi Gezileri", "Bilimsel Sempozyumlar", "Bilimsel Söyleşiler", "Sahaf Gezileri", "Lewontin Çalıştayı", "Akademik Sunumlar"],
      highlights: [
        "Evrimsel biyoloji ve tıp alanında bilinç oluşturma",
        "Bilimsel sempozyumlar ve söyleşiler",
        "Arazi gezileri ve sahaf gezileri",
        "Lewontin Çalıştayı ve akademik sunumlar"
      ],
      isActive: true,
      color: "indigo"
    },
    {
      id: 2,
      name: "Ekoloji Grubu Topluluğu (EKOG)",
      category: "akademik",
      department: "Biyoloji Bölümü",
      description: "Hacettepe Üniversitesi Biyoloji Bölümü öğrencileri tarafından 2002 yılında kurulan Ekoloji Grubu Topluluğu (EKOG); doğayı, ekolojiyi ve araştırmayı odağına alan aktif bir öğrenci topluluğudur. Her yıl düzenlenen Hacettepe Biyoloji ve Uygulamaları Kongresi (HBUK) ve Biyocoğrafya Konferansı gibi gelenekselleşmiş etkinlikler aracılığıyla öğrencileri alanında uzman akademisyenlerle buluşturur; yeni konularla tanışma ve ilgi alanlarını keşfetme imkanı sunar. Yeşil Vadi gibi arazi gezileri ve çeşitli atölyelerle katılımcıların hem sahada hem laboratuvarda deneyim kazanmasını destekler. Ayrıca akademik yazım alanında rehberlik sağlayarak üyelerini bilimsel üretime teşvik eder; hazırlanan yazılar sosyal medya hesaplarımızda paylaşılır. Güncel etkinliklerimizden haberdar olmak için Instagram ve Twitter'da @huekog hesabımızı takip edebilirsiniz. Doğaya, bilime ve birlikte öğrenmeye meraklıysanız, EKOG tam size göre!",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/ekoglogo.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/Biyoco%C4%9Frafya%20Konferans%C4%B1%20.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/ekog-arazi.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/ekog-arazi2.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/geleneksel-yesil-vadi.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hbuk-afis.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hbuk-calistay.jpg"
      ],
      foundedYear: "2002",
      contact: {
        instagram: "@huekog",
        twitter: "@huekog"
      },
      activities: ["HBUK", "Biyocoğrafya Konferansı", "Arazi Gezileri", "Yeşil Vadi", "Atölyeler", "Akademik Yazım"],
      highlights: [
        "Hacettepe Biyoloji ve Uygulamaları Kongresi (HBUK)",
        "Biyocoğrafya Konferansı",
        "Yeşil Vadi arazi gezileri",
        "Akademik yazım rehberliği"
      ],
      isActive: true,
      color: "green"
    },
    {
      id: 3,
      name: "Matematiksel Düşünce ve Araştırma Topluluğu (HUMDAT)",
      category: "akademik",
      department: "Matematik Bölümü",
      description: "Üniversitemizde matematik kültürünü yaşatmaya çalışan bir grup öğrenciyiz. Matematiğin sadece bir araç olarak kullanıldığı derslerimizin yanı sıra matematiği bir amaç olarak görüyoruz. Bu bakış açısıyla haftalık etkinlikler düzenliyoruz. Bazı etkinliklerimiz doğrudan akademik fayda gütse de bazı etkinliklerimiz yalnızca matematiksel bir sosyal ortam oluşturmayı amaçlıyor. Düzenlediğimiz etkinlikleri şöyle listeleyebiliriz: 1. Akademisyen Seminerleri 2. Matematiksel Oyunlar 3. Öğrenci Seminerleri 4. Matematiksel Yarışmalar 5. Film İzleme ve Üzerine Tartışma",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/humdatlogo.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk2.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk3.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk4.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk5.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk6.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/mtk7.jpg"
      ],
      foundedYear: "2020",
      contact: {
        instagram: "@humdat_17"
      },
      activities: ["Akademisyen Seminerleri", "Matematiksel Oyunlar", "Öğrenci Seminerleri", "Matematiksel Yarışmalar", "Film İzleme"],
      highlights: [
        "Akademisyen seminerleri",
        "Matematiksel oyunlar ve yarışmalar",
        "Öğrenci seminerleri",
        "Film izleme ve tartışma etkinlikleri"
      ],
      isActive: true,
      color: "blue"
    },
    {
      id: 4,
      name: "Hacettepe İstatistik ve Veri Bilimi Topluluğu (HÜİST)",
      category: "akademik",
      department: "İstatistik Bölümü",
      description: "HÜİST, istatistik ve veri bilimi alanında öğrencilerin potansiyelini ortaya çıkararak onları analitik ve yetkin bireyler olarak gelişimlerini desteklemeyi amaçlar. Topluluğumuz, bu doğrultuda sektörden uzman isimlerin bilgi ve deneyimlerini aktardığı Data Talks etkinlikleri, sektörde ihtiyaç duyulan teknik eğitimler ve workshoplar, teknik geziler, mezun buluşmaları düzenlemektedir. HÜİST, üyelerinin hem teorik bilgi birikimini artırmayı hem de iş dünyasıyla bağlantı kurmalarını sağlayarak kariyer yolculuklarına yön vermeyi hedeflemektedir.",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huistlogo.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist1.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist2.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist3.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist4.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist5.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist6.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist7.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist8.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/huist9.jpg"
      ],
      foundedYear: "2021",
      contact: {
        instagram: "@huistatistik"
      },
      activities: ["Data Talks", "Teknik Eğitimler", "Workshoplar", "Teknik Geziler", "Mezun Buluşmaları"],
      highlights: [
        "Data Talks etkinlikleri",
        "Sektörel teknik eğitimler ve workshoplar",
        "Teknik geziler",
        "Mezun buluşmaları ve networking"
      ],
      isActive: true,
      color: "purple"
    },
    {
      id: 5,
      name: "Hacettepe Üniversitesi Biyoloji Topluluğu (HÜBİTO)",
      category: "akademik",
      department: "Biyoloji Bölümü",
      description: "Hacettepe Üniversitesi Biyoloji Topluluğu (HÜBİTO) olarak, biyolojiyi yalnızca ders kitaplarında değil; doğada, müzelerde, sinema perdesinde ve saha çalışmalarında deneyimlemeye inanıyoruz. Bilimi seven, doğayı merak eden ve birlikte öğrenmek isteyen herkesi bir araya getiren bir topluluğuz. Etkinliklerimiz yıl boyunca çeşitlilik gösteriyor. Her dönem düzenli olarak gerçekleştirdiğimiz bazı etkinliklerimiz şunlardır: • Kuş Gözlem Etkinlikleri ile doğaya çıkıyor, farklı kuş türlerini gözlemleyerek ekolojik ilişkileri yerinde inceliyoruz. • Sürüngen Arazileri sayesinde Ankara ve çevresindeki saha alanlarında sürüngen türlerini tanıma, fotoğraflama ve gözlem yapma fırsatı buluyoruz. • Müze Gezileri ile doğal tarih, evrim ve paleontoloji konularını zengin bir koleksiyon eşliğinde keşfediyoruz. • Sinema Günlerinde ise doğa ve bilim temalı film ve belgeseller izleyerek üzerine sohbet ediyor, birlikte düşünme alanları yaratıyoruz. Topluluğumuz, biyolojiyi yaşamın içine taşıyan, doğaya duyarlı, paylaşmayı seven herkesin buluşma noktası. Eğer sen de doğayla bağ kurmak, araştırmak ve birlikte üretmek istiyorsan seni de bekliyoruz.",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubitologo2.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito1.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito2.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito3.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito4.webp",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito5.webp",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito6.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito7.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito8.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito9.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hubito10.jpg"
      ],
      foundedYear: "2019",
      contact: {
        instagram: "@hubito98"
      },
      activities: ["Kuş Gözlem Etkinlikleri", "Sürüngen Arazileri", "Müze Gezileri", "Sinema Günleri"],
      highlights: [
        "Kuş gözlem etkinlikleri",
        "Sürüngen arazileri ve saha çalışmaları",
        "Müze gezileri",
        "Doğa ve bilim temalı sinema günleri"
      ],
      isActive: true,
      color: "emerald"
    },
    {
      id: 6,
      name: "Genç Kimyacılar Topluluğu (GKT)",
      category: "akademik",
      department: "Kimya Bölümü",
      description: "Kimya alanında bilimsel etkinlikler düzenleyen ve öğrencilerin kimya bilimindeki gelişimlerini destekleyen topluluk.",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/gktlogo.jfif",
      images: [],
      foundedYear: "2018",
      contact: {
        instagram: "@genckimyacilar"
      },
      activities: ["Kimya Seminerleri", "Laboratuvar Çalışmaları", "Sektörel Geziler"],
      highlights: [
        "Kimya seminerleri",
        "Uygulamalı laboratuvar çalışmaları",
        "Sektörel teknik geziler"
      ],
      isActive: true,
      color: "orange",
      video: "/genc-kimyacilar-toplulugu-tanitim-videosu.mp4"
    },
    {
      id: 7,
      name: "Hacettepe Üniversitesi Risk ve Aktüerya Topluluğu (HÜRAT)",
      category: "akademik",
      department: "Aktüerya Bilimleri Bölümü",
      description: "Misyon: Hacettepe Üniversitesi Risk ve Aktüerya Topluluğu'nun misyonu, risk analizi, finansal matematik ve sigortacılık alanlarında bilgi birikimi sağlamak, üyelerine akademik ve profesyonel gelişim imkânları sunarak onları gelecekteki meslek hayatına hazırlamaktır. Topluluğumuz, öğrencilere sektördeki güncel gelişmeleri yakından takip etmelerini sağlayacak etkinlikler düzenleyerek, sosyal ve akademik network'lerini güçlendirmelerine katkıda bulunur.Bu etkinliklerin başında da gelenekselleşen Risk Günleri etkinliğimiz bulunur.Çeşitli sektörlerden alanlarında yetkin konuşmacılarımızın deneyimlerini bizlerle paylaştığı bu etkinliğimizde amacımız aktüerya bilimleri mezunlarının hem çok geniş bir yelpazede iş bulabildiklerini hem de ne kadar değerli bir bölümde okuduklarını alanlarında yetkin kişilerden  duymasıdır. Vizyon:Hacettepe Üniversitesi Risk ve Aktüerya Topluluğu'nun vizyonu, ulusal ve uluslararası düzeyde aktüerya ve finans alanında öncü bireyler yetiştiren, sektörde fark yaratan bir öğrenci topluluğu olmaktır.Topluluğumuz sektördeki yeniliklere hızlı uyum sağlayan, disiplinler arası düşünebilen ve etik değerlere bağlı profesyoneller yetiştirerek, topluluğumuzun hem yerel hem de küresel platformlarda tanınan bir marka haline gelmesini hedeflemektedir. Bu misyon ve vizyon, topluluğun hem akademik hem de kariyer odaklı bir gelişim sağlama hedefini vurgular ve sektörel başarıyı hedefleyen bir perspektif sunar.",
      logo: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/424480167_24778231188487493_572115813971081527_n.jpg",
      images: [
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/hurat1.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/485584228_18492347215031754_6882533688705994706_n.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/485758207_18492347332031754_2167644910676713306_n.jpg",
        "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/470428817_2041809119574032_1733293000939037743_n.webp"
      ],
      foundedYear: "2023",
      contact: {
        instagram: "@hurathacettepe"
      },
      activities: ["Risk Günleri", "Sektörel Seminerleri", "Akademik Workshoplar", "Network Etkinlikleri", "Profesyonel Gelişim Programları"],
      highlights: [
        "Risk Günleri etkinlikleri",
        "Sektörel konuşmacılar ile buluşma",
        "Akademik ve profesyonel gelişim",
        "Finans ve sigortacılık alanında networking"
      ],
      isActive: true,
      color: "red",
      video: "https://fs.hacettepe.edu.tr/fenyeni/ogrencitopluluklari/h%C3%BCrat-tan%C4%B1t%C4%B1m.gif"
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  const scrollToClub = (clubId) => {
    const element = document.getElementById(`club-${clubId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <PageTemplate
      title="Öğrenci Toplulukları"
      subtitle="Fen Fakültesi öğrenci topluluklarını keşfedin, yeni arkadaşlar edinin ve ilgi alanlarınızda aktif olarak yer alın."
    >
      <div className="space-y-16">
        {/* Club Logos Section */}
        <motion.div 
          className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12 border border-gray-100"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">Öğrenci Toplulukları</h2>
            <p className="text-gray-600 text-lg">Logoları tıklayarak topluluk detaylarına ulaşabilirsiniz</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {clubs.map((club, index) => (
              <motion.div
                key={club.id}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                onClick={() => scrollToClub(club.id)}
                className="group cursor-pointer"
              >
                <div className="relative bg-gradient-to-br from-gray-50 to-white p-4 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 hover:border-blue-400 transform hover:scale-105 min-h-[120px] flex flex-col justify-center">
                  <div className="w-16 h-16 mx-auto mb-3 rounded-xl bg-white shadow-md flex items-center justify-center overflow-hidden group-hover:scale-110 transition-transform duration-300">
                    <img 
                      src={club.logo} 
                      alt={`${club.name} logo`}
                      className="w-12 h-12 object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 hidden">
                      <FaUsers className="text-xl" />
                    </div>
                  </div>
                  
                  <div className="text-center">
                    <h3 className="font-semibold text-xs text-gray-800 mb-1 group-hover:text-blue-600 transition-colors leading-tight">
                      {(() => {
                        if (club.name.includes('HÜEBTTO')) return 'Evrimsel Biyoloji ve Tıp Topluluğu';
                        if (club.name.includes('EKOG')) return 'Ekoloji Grubu Topluluğu';
                        if (club.name.includes('HUMDAT')) return 'Matematiksel Düşünce Topluluğu';
                        if (club.name.includes('HÜİST')) return 'İstatistik ve Veri Bilimi Topluluğu';
                        if (club.name.includes('HÜBİTO')) return 'Biyoloji Topluluğu';
                        if (club.name.includes('GKT')) return 'Genç Kimyacılar Topluluğu';
                        if (club.name.includes('HÜRAT')) return 'Risk ve Aktüerya Topluluğu';
                        return club.name.length > 12 ? club.name.substring(0, 12) + '...' : club.name;
                      })()}
                    </h3>
                    <p className="text-xs text-gray-500 opacity-70">{club.department.split(' ')[0]}</p>
                  </div>
                  
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-400/10 to-blue-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Premium Clubs Layout */}
        <motion.div 
          className="space-y-16"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {clubs.map((club, index) => (
              <motion.div
                key={club.id}
                id={`club-${club.id}`}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={index}
                className="relative bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 hover:shadow-3xl transition-all duration-700"
              >
                {/* Premium Header with Logo and Info */}
                <div className={`relative h-32 bg-gradient-to-r from-${club.color}-500 via-${club.color}-600 to-${club.color}-700 overflow-hidden`}>
                  <div className="absolute inset-0">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                    <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/4"></div>
                  </div>
                  
                  <div className="relative z-10 p-4 md:p-8 flex items-center justify-between h-full">
                    <div className="flex items-center space-x-4 md:space-x-6 flex-1">
                      {/* Premium Logo Container - Hidden on mobile */}
                      <div className="hidden md:flex w-16 h-16 rounded-2xl bg-white shadow-xl items-center justify-center overflow-hidden group-hover:scale-110 transition-transform duration-500">
                        <img 
                          src={club.logo} 
                          alt={`${club.name} logo`}
                          className="w-12 h-12 object-contain"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 hidden">
                          <FaUsers className="text-xl" />
                        </div>
                      </div>
                      
                      {/* Club Title */}
                      <div className="text-white flex-1">
                        <h2 className="text-lg md:text-2xl font-bold mb-1 leading-tight">{club.name}</h2>
                        <div className="flex items-center text-xs md:text-sm text-white/80">
                          <span className="flex items-center">
                            <FaMapMarkerAlt className="mr-1" />
                            {club.department}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Status and Actions */}
                    <div className="flex items-center space-x-3">
                      <span className={`px-4 py-2 rounded-xl text-sm font-medium ${
                        club.isActive ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'
                      }`}>
                        {club.isActive ? '✓ Aktif' : '○ Pasif'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Main Content Area */}
                <div className="p-8 lg:p-10">
                  <div className="grid lg:grid-cols-3 gap-8">
                    {/* Left Column - Description */}
                    <div className="lg:col-span-2 space-y-6">
                      {/* Description */}
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">Topluluk Hakkında</h3>
                        <div className={`text-gray-700 leading-relaxed ${
                          expandedClub === club.id ? '' : 'line-clamp-4'
                        }`}>
                          {club.description}
                        </div>
                        <button
                          onClick={() => setExpandedClub(expandedClub === club.id ? null : club.id)}
                          className="mt-3 text-blue-600 hover:text-blue-700 font-medium text-sm flex items-center transition-colors"
                        >
                          {expandedClub === club.id ? (
                            <>
                              <FaChevronUp className="mr-1" />
                              Daha Az Göster
                            </>
                          ) : (
                            <>
                              <FaChevronDown className="mr-1" />
                              Devamını Oku
                            </>
                          )}
                        </button>
                      </div>

                      {/* Activities Grid or List */}
                      <div>
                        <h4 className="text-lg font-bold text-gray-800 mb-4">Etkinlikler</h4>
                        {club.name.includes('HÜBİTO') ? (
                          <div className="space-y-2">
                            {club.activities.map((activity, idx) => (
                              <div
                                key={idx}
                                className="flex items-center p-3 bg-emerald-50 border border-emerald-100 rounded-xl transition-all duration-300 hover:shadow-lg"
                              >
                                <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3 flex-shrink-0"></div>
                                <span className="text-emerald-700 font-medium text-sm">
                                  {activity}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                            {club.activities.map((activity, idx) => (
                              <div
                                key={idx}
                                className="p-3 bg-gray-50 border border-gray-100 rounded-xl text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
                              >
                                <span className="text-gray-700 font-medium text-sm">
                                  {activity}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Special Video Section */}
                      {club.video && (
                        <div>
                          <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                            <FaVideo className="mr-2 text-red-500" />
                            Tanıtım Videosu
                          </h4>
                          <div className="relative">
                            {club.video.includes('.gif') ? (
                              <div className="w-full rounded-2xl overflow-hidden shadow-lg">
                                <img 
                                  src={club.video} 
                                  alt={`${club.name} tanıtım videosu`}
                                  className="w-full h-auto object-cover"
                                />
                              </div>
                            ) : (
                              <button
                                onClick={() => setSelectedVideo(club.video)}
                                className="w-full bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white p-6 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-xl group relative overflow-hidden"
                              >
                                <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <div className="relative z-10 flex items-center justify-center space-x-4">
                                  <div className="bg-white/20 p-4 rounded-full group-hover:scale-110 transition-transform duration-300">
                                    <FaPlay className="text-2xl" />
                                  </div>
                                  <div className="text-left">
                                    <div className="font-bold text-lg">Tanıtım Videosunu İzle</div>
                                    <div className="text-red-100 text-sm">Topluluğumuzu daha yakından tanıyın</div>
                                  </div>
                                </div>
                                <div className="absolute top-2 right-2 opacity-30 group-hover:opacity-50 transition-opacity">
                                  <FaVideo className="text-3xl" />
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Right Column - Media and Contact */}
                    <div className="space-y-6">
                      {/* Image Gallery */}
                      {club.images && club.images.length > 0 && (
                        <div>
                          <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                            <FaImage className="mr-2 text-purple-500" />
                            Etkinlik Fotoğrafları
                          </h4>
                          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                            {club.images.map((image, idx) => (
                              <div
                                key={idx}
                                onClick={() => {
                                  setSelectedImage(club.images);
                                  setCurrentImageIndex(idx);
                                }}
                                className="relative aspect-square rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer group"
                              >
                                <img
                                  src={image}
                                  alt={`${club.name} etkinlik ${idx + 1}`}
                                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                  onError={(e) => {
                                    e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxjaXJjbGUgY3g9IjEwMCIgY3k9IjEwMCIgcj0iMzAiIGZpbGw9IiM5Q0E0QUYiLz4KPC9zdmc+";
                                  }}
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                                  <FaExpand className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                </div>
                              </div>
                            ))}
                          </div>
                          <p className="text-sm text-gray-500 mt-2 text-center">
                            Toplam {club.images.length} fotoğraf
                          </p>
                        </div>
                      )}

                      {/* Contact Information */}
                      <div className={`p-6 bg-gradient-to-br from-${club.color}-50 to-${club.color}-100 rounded-2xl border border-${club.color}-200`}>
                        <h4 className="text-lg font-bold text-gray-800 mb-4">İletişim</h4>
                        <div className="space-y-3">
                          <a 
                            href={`https://instagram.com/${club.contact.instagram ? club.contact.instagram.replace('@', '') : club.name.toLowerCase().split(' ').join('')}`}
                            target="_blank"
                            rel="noopener noreferrer" 
                            className="flex items-center p-3 bg-white rounded-xl hover:shadow-lg transition-all duration-300 group"
                          >
                            <FaInstagram className="text-pink-500 text-xl mr-3" />
                            <div>
                              <div className="font-medium text-gray-800">Instagram</div>
                              <div className="text-sm text-gray-600">{club.contact.instagram || '@' + club.name.toLowerCase().split(' ').join('')}</div>
                            </div>
                            <FaExternalLinkAlt className="ml-auto text-gray-400 group-hover:text-gray-600" />
                          </a>
                          
                          {club.contact.twitter && (
                            <a 
                              href={`https://twitter.com/${club.contact.twitter.replace('@', '')}`}
                              target="_blank"
                              rel="noopener noreferrer" 
                              className="flex items-center p-3 bg-white rounded-xl hover:shadow-lg transition-all duration-300 group"
                            >
                              <FaTwitter className="text-blue-400 text-xl mr-3" />
                              <div>
                                <div className="font-medium text-gray-800">Twitter</div>
                                <div className="text-sm text-gray-600">{club.contact.twitter}</div>
                              </div>
                              <FaExternalLinkAlt className="ml-auto text-gray-400 group-hover:text-gray-600" />
                            </a>
                          )}
                          
                          {club.contact.facebook && (
                            <a 
                              href={club.contact.facebook}
                              target="_blank"
                              rel="noopener noreferrer" 
                              className="flex items-center p-3 bg-white rounded-xl hover:shadow-lg transition-all duration-300 group"
                            >
                              <FaFacebook className="text-blue-600 text-xl mr-3" />
                              <div>
                                <div className="font-medium text-gray-800">Facebook</div>
                                <div className="text-sm text-gray-600">HÜEBTO</div>
                              </div>
                              <FaExternalLinkAlt className="ml-auto text-gray-400 group-hover:text-gray-600" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
        </motion.div>


        {/* Image Modal */}
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
              onClick={() => setSelectedImage(null)}
            >
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.8 }}
                className="relative max-w-6xl max-h-full"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedImage[currentImageIndex]}
                  alt={`Fotoğraf ${currentImageIndex + 1}`}
                  className="max-w-full max-h-full object-contain rounded-lg"
                />
                
                {/* Navigation */}
                {selectedImage.length > 1 && (
                  <>
                    <button
                      onClick={() => setCurrentImageIndex((prev) => (prev - 1 + selectedImage.length) % selectedImage.length)}
                      className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300"
                    >
                      <FaChevronLeft />
                    </button>
                    <button
                      onClick={() => setCurrentImageIndex((prev) => (prev + 1) % selectedImage.length)}
                      className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300"
                    >
                      <FaChevronRight />
                    </button>
                  </>
                )}
                
                {/* Close button */}
                <button
                  onClick={() => setSelectedImage(null)}
                  className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-lg hover:bg-black/70 transition-colors"
                >
                  ✕
                </button>
                
                {/* Image counter */}
                {selectedImage.length > 1 && (
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-sm">
                    {currentImageIndex + 1} / {selectedImage.length}
                  </div>
                )}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Video Modal */}
        <AnimatePresence>
          {selectedVideo && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
              onClick={() => setSelectedVideo(null)}
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                className="relative max-w-5xl w-full"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="bg-black rounded-2xl overflow-hidden shadow-2xl">
                  <video 
                    controls 
                    autoPlay
                    className="w-full h-auto max-h-[80vh]"
                  >
                    <source src={selectedVideo} type="video/mp4" />
                    Tarayıcınız video oynatmayı desteklemiyor.
                  </video>
                </div>
                
                {/* Close button */}
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="absolute -top-4 -right-4 bg-red-500 hover:bg-red-600 text-white p-3 rounded-full transition-colors shadow-lg"
                >
                  ✕
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </PageTemplate>
  );
};

export default OgrenciTopluluklari;